import { readBodegaRecogida } from './orderBodegaRecogida'

export const STATUS_SIN_STOCK_FLEXY = 'sin_stock_flexy'
export const STATUS_PROCESSING = 'processing'
export const STATUS_ASIGNADO = 'asignado'

export function selectSinStockFlexyOrders<T extends { status: string }>(orders: T[]): T[] {
  return orders.filter((order) => order.status === STATUS_SIN_STOCK_FLEXY)
}

export function selectProcessingRecogeEnBodegaOrders<T extends { status: string }>(orders: T[]): T[] {
  return orders.filter((order) => {
    if (order.status !== STATUS_PROCESSING) return false
    return readBodegaRecogida(order).recogeRespuesta === 'si'
  })
}

export async function asignarPedidosSinStockFlexy(
  orders: Array<{ id: number }>,
  updateStatus: (orderId: number, status: string) => Promise<unknown>
): Promise<{ ok: number; failed: number }> {
  let ok = 0
  let failed = 0

  for (const order of orders) {
    try {
      await updateStatus(order.id, STATUS_ASIGNADO)
      ok += 1
    } catch {
      failed += 1
    }
  }

  return { ok, failed }
}
